import { useRef, useState } from "react";
import { toast } from "sonner";
import { Loader2, Plus, X } from "lucide-react";
import { api, fileUrl } from "@/lib/api";

/** Uploads images to object storage and manages an array of URLs. */
export default function ImageUploader({ value = [], onChange, max = 8, single = false, testid = "uploader", hint = "" }) {
  const [busy, setBusy] = useState(false);
  const inputRef = useRef(null);

  const handleFiles = async (files) => {
    const list = Array.from(files);
    if (!list.length) return;
    setBusy(true);
    try {
      const urls = [];
      for (const f of list) {
        const fd = new FormData();
        fd.append("file", f);
        const { data } = await api.post("/admin/upload", fd, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        urls.push(data.url);
      }
      let next = single ? urls.slice(0, 1) : [...value, ...urls].slice(0, max);
      onChange(next);
      toast.success("Imagen(es) subida(s)");
    } catch (e) {
      toast.error("Error al subir imagen");
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  const remove = (i) => onChange(value.filter((_, idx) => idx !== i));

  return (
    <div>
      <div className="flex flex-wrap gap-3">
        {value.map((u, i) => (
          <div key={i} className="relative h-20 w-20 overflow-hidden rounded-xl ring-1 ring-neutral-200">
            <img src={fileUrl(u)} alt="" className="h-full w-full object-cover" />
            <button
              type="button"
              onClick={() => remove(i)}
              className="absolute right-1 top-1 grid h-5 w-5 place-items-center rounded-full bg-black/60 text-white"
            >
              <X className="h-3 w-3" />
            </button>
          </div>
        ))}
        {(single ? value.length < 1 : value.length < max) && (
          <button
            type="button"
            data-testid={`${testid}-add`}
            onClick={() => inputRef.current?.click()}
            className="grid h-20 w-20 place-items-center rounded-xl border-2 border-dashed border-neutral-300 text-neutral-400 hover:border-neutral-500"
          >
            {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : <Plus className="h-6 w-6" />}
          </button>
        )}
      </div>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        multiple={!single}
        className="hidden"
        onChange={(e) => handleFiles(e.target.files)}
      />
      {hint && <p className="mt-2 text-xs text-neutral-400">{hint}</p>}
    </div>
  );
}
